// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3tmck","HeadImg":"Home_HeadImg__HAAUm","productsLayout":"Home_productsLayout__3t0i9","servicesContainer":"Home_servicesContainer__2OB4H"};